import { EndPoints } from '../api-config';
import * as R from 'ramda';
import JwtDecode from 'jwt-decode';
// import * as qs from 'querystring';

let SERVER_ADDR_V1 = EndPoints.backendHost;
// const version = 'v1';

export const getAuthenticationUrl = (state) => {
    var nonce = "";
    var possible = "0123456789";
    for (var i = 0; i < 12; i++) {
        nonce += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    // let state = new URLSearchParams(window.location.search).get("state");
    // if (R.isNil(state)) {
    //     let query = qs.parse(window.location.hash.substring(1));
    //     state = query.state;
    // }

    // const hostname = window && window.location && window.location.hostname;
    // if (EndPoints.environment === "production") {
    //     return "https://accounts.securibox.eu/id/connect/authorize?client_id=00000000000000000000000000000000&redirect_uri=" + encodeURI(window.location.protocol + "//" + hostname + (window.location.port ? ':' + window.location.port : '')) + "&response_mode=fragment&response_type=token+id_token&scope=openid%20sbx-id/api:read%20sbx-id/api:write&nonce=" + nonce + (!R.isNil(state) ? ('&state=' + state) : '');
    // } else {
    //     return "https://accounts-dev.securibox.eu/id/connect/authorize?client_id=00000000000000000000000000000000&redirect_uri=" + encodeURI(window.location.protocol + "//" + hostname + (window.location.port ? ':' + window.location.port : '')) + "&response_mode=fragment&response_type=token+id_token&scope=" + encodeURI("openid sbx-id/api:read sbx-id/api:write") + "&nonce=" + nonce + (!R.isNil(state) ? ('&state=' + state) : '');
    // }

    const hostname = window && window.location && window.location.hostname;
    return "https://" + (EndPoints.environment === "production" ? "accounts" : "accounts-dev") + ".securibox.eu/id/connect/authorize?client_id=00000000000000000000000000000000&redirect_uri=" + encodeURI(window.location.protocol + "//" + hostname + (R.isNil(window.location.port) || window.location.port === '' ? '' : (':' + window.location.port))) + "&response_mode=fragment&response_type=token+id_token&scope=" + encodeURI("openid sbx-id/api:read sbx-id/api:write") + "&nonce=" + nonce + (!R.isNil(state) ? ('&state=' + state) : '');
};

function getUserId() {
    var accessToken = sessionStorage.getItem("access_token");
    if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
        var decoded = JwtDecode(accessToken);
        if (!R.isNil(decoded) && !R.isNil(decoded.sub)) {
            return decoded.sub;
        }
    }
    window.location = getAuthenticationUrl();
};


export const ACCOUNT_URL = `${SERVER_ADDR_V1}/api/users/${getUserId()}`;
export const PASSWORD_URL = `${SERVER_ADDR_V1}/api/users/${getUserId()}/password`;
export const PROFILE_IMAGE_URL = `${SERVER_ADDR_V1}/api/users/${getUserId()}/picture`;
export const APPLICATIONS_URL = `${SERVER_ADDR_V1}/api/applications`;